@if (workPackage) {
  <div class="detail-panel-description detail-panel--relations detail-panel--autocomplete-target"
    >
    <div class="detail-panel-description-content">
      <wp-relations [workPackage]="workPackage" />
    </div>
  </div>
}
